import { Link } from "gatsby";
import React from "react";
import logo from "../images/logo.png";
import { BtnOutline } from "./buttons/BtnOutline";
import JapanFlag from "../images/japan-flag.svg";
import { BtnPrimary } from "./buttons/BtnPrimary";
import twitter from "../images/twitter1.svg";
import facebook from "../images/fb1.svg";
import instagram from "../images/insta1.svg";
import linkedin from "../images/linkedin1.svg";
import ourteam from "../images/our-team-icon.png";
import culture from "../images/culture-values.png";
import company from "../images/our-company.png";
import services from "../images/our-services.png";
import whatwedo from "../images/what-we-do.png";
import health from "../images/healthcare-tran.png";
import provider from "../images/provider-search.png";
import blogs from "../images/blog-article.png";
import casestudy from "../images/case-study.png";
import mrfnav from "../images/MRF-nav.png";
import news from "../images/news-icon.png";
import media from "../images/media.png";

const Header = () => {
  return (
    <nav className="navbar navbar-light navbar-expand-lg fixed-top">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img
            src={logo}
            alt="Deerhold"
            width="150"
            className="d-inline-block align-text-top"
          />
        </Link>{" "}
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <a class="navicon-button x">
            <div class="navicon"></div>
          </a>
        </button>
        <div class="collapse navbar-collapse pt-2" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-lg-none d-block fs-4">
            <li class="nav-item">
              <a
                class="nav-link nav-mobile d-flex align-items-center"
                data-bs-toggle="collapse"
                href="#about"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                About
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </span>
                {/* <img src={downArrow} alt="downArrow" className="down-arrow" /> */}
              </a>

              <ul
                class="navbar-nav accordion-collapse collapse align-items-center"
                id="about"
              >
                <li>
                  <a
                    class="nav-link  nav-mobile d-flex align-items-center"
                    href="/our-team"
                  >
                    Our Team
                  </a>
                </li>
                <li>
                  <a
                    class="nav-link  nav-mobile d-flex align-items-center"
                    href="/culture-values"
                  >
                    Our Culture and Values
                  </a>
                </li>
                <li>
                  <a
                    class="nav-link  nav-mobile d-flex align-items-center"
                    href="/our-company"
                  >
                    Why Deerhold?
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <a
                class="nav-link  nav-mobile d-flex align-items-center"
                data-bs-toggle="collapse"
                href="#solution"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Solutions
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </span>
              </a>
              <ul class="navbar-nav collapse accordion-collapse" id="solution">
                <li>
                  <li>
                    <a
                      class="nav-link  nav-mobile d-flex align-items-center"
                      href="/contract-rate-explorer"
                    >
                      Contract Rate Explorer
                    </a>
                  </li>
                  <a
                    class="nav-link  nav-mobile d-flex align-items-center"
                    href="/tara"
                  >
                    TARA
                  </a>
                </li>
                {/* <li>
                  <a
                    class="nav-link  nav-mobile d-flex align-items-center"
                    href="/provider-search"
                  >
                    Provider Search
                  </a>
                </li> */}
              </ul>
            </li>

            <li class="nav-item">
              <a
                class="nav-link  nav-mobile d-flex align-items-center"
                href="/our-services"
              >
                Services
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link nav-mobile d-flex align-items-center"
                href="/what-we-do"
              >
                What We Do
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link  nav-mobile d-flex align-items-center"
                href="/careers"
              >
                Careers
              </a>
            </li>

            {/* <li class="nav-item">
              <a class="nav-link" href="/insights">
                Insights
              </a>
            </li> */}

            <li class="nav-item">
              <a
                class="nav-link nav-mobile d-flex align-items-center"
                data-bs-toggle="collapse"
                href="#insights"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Resources
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                    />
                  </svg>
                </span>
              </a>

              <ul
                class="navbar-nav accordion-collapse collapse align-items-center"
                id="insights"
              >
                <li>
                  <a class="nav-link" href="/insights">
                    Case Study
                  </a>
                </li>
                <li>
                  <a class="nav-link" href="/blogs">
                    Blogs
                  </a>
                </li>
                <li>
                  <a class="nav-link" href="/news-list">
                    News
                  </a>
                </li>
                <li>
                  <a class="nav-link" href="/media">
                    Media
                  </a>
                </li>
              </ul>
            </li>

            <li class="nav-item ">
              <a
                class="nav-link  mt-2"
                href="https://japan.deerhold.com"
                target="_blank"
              >
                Deerhold Japan{" "}
                <span>
                  <img src={JapanFlag} alt="Japan" className="japanFlag ms-2" />
                </span>
              </a>
            </li>
          </ul>
          <div className="nav-footer d-block d-lg-none text-left">
            <BtnPrimary btnText="Contact Us" link="/contact" />
            {/* <a
                className="nav-link ps-3"
                to="https://japan.deerhold.com/"
                target="_blank"
              >
                <img src={JapanFlag} alt="Japan" className="japanFlag" />
              </a> */}
            <div className="social-icons d-flex justify-content-evenly mt-4">
              <a href="https://twitter.com/deerholdltd">
                {" "}
                <img src={twitter} alt="twitterIcon" />
              </a>
              <a href="https://www.facebook.com/deerhold">
                <img src={facebook} alt="facebookIcon" />
              </a>
              <a href="https://www.linkedin.com/company/deerhold/">
                <img src={linkedin} alt="linkedinIcon" />
              </a>
              <a href="https://www.instagram.com/deerhold/">
                <img src={instagram} alt="instagramIcon" />
              </a>
            </div>
          </div>
        </div>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNavAltMarkup"
        >
          <div className="navbar-nav d-none d-lg-flex" id="nav-dropdown">
            <li>
              <a class="nav-link about-link" role="button">
                About
              </a>
              <div class="collapse about-nav">
                <div class="nav-full-dropdown ">
                  <div className="container text-left">
                    <div className="row nav">
                      <Link className="col-lg-3 col-12" to="/our-team">
                        <div className="nav-bar-style ">
                          <img src={ourteam} alt="our-team" />

                          <div className="nav-details">
                            <a href="/our-team">Our Team</a>
                            <p className="mt-1 text-left">
                              Read our origin story and meet the talented people
                              leading our company.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-3 col-12" to="/culture-values">
                        <div className="nav-bar-style ">
                          <img src={culture} alt="culture-values" />

                          <div className="nav-details">
                            <a href="/culture-values">Our Culture and Values</a>
                            <p className="mt-1 text-left">
                              Learn what matters to us and how this influences
                              our team and our work.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-3 col-12" to="/our-company">
                        <div className="nav-bar-style ">
                          <img src={company} alt="culture-values" />

                          <div className="nav-details">
                            <a href="/our-company">Why Deerhold?</a>
                            <p className="mt-1 text-left">
                              Get to know our company a bit better and learn how
                              we can help you.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a class="nav-link solutions-link" role="button">
                Solutions
              </a>
              <div class="collapse solutions-nav">
                <div class="nav-full-dropdown ">
                  <div className="container text-left">
                    <div className="row">
                      <Link
                        className="col-lg-6 col-12"
                        to="/contract-rate-explorer"
                      >
                        <div className="nav-bar-style ">
                          <img src={mrfnav} alt="MRF" />

                          <div className="nav-details">
                            <a href="/contract-rate-explorer">
                              Contract Rate Explorer
                            </a>
                            <p className="mt-1 text-left">
                              Inform business decisions by unlocking the power
                              of payer MRFs for actionable insights that are
                              relevant for your specific needs.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-6 col-12" to="/tara">
                        <div className="nav-bar-style ">
                          <img
                            src={health}
                            alt="Tara"
                            className="our-team-icon"
                          />

                          <div className="nav-details">
                            <a href="/tara">TARA</a>
                            <p className="mt-1 text-left">
                              Get compliant and stay compliant with Tara, an
                              online tool that allows members to estimate cost
                              sharing for covered healthcare items and services.
                            </p>
                          </div>
                        </div>
                      </Link>
                      {/* <Link className="col-lg-4 col-12" to="/provider-search">
                        <div className="nav-bar-style ">
                          <img src={provider} alt="provider-search" />

                          <div className="nav-details">
                            <a href="/provider-search">Provider Search</a>
                            <p className="mt-1 text-left">
                              Give members an online provider search tool that
                              lets them look for providers by name, specialty,
                              facility, network, or location.
                            </p>
                          </div>
                        </div>
                      </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a className="nav-link services-link" role="button">
                Services
              </a>
              <div className="collapse services-nav">
                <div className="nav-full-dropdown ">
                  <div className="container text-left">
                    <div className="row">
                      <Link className="col-lg-5 col-12" to="/our-services">
                        <div className="nav-bar-style ">
                          <img src={services} alt="our-services" />

                          <div className="nav-details">
                            <a href="/our-services">Our Services</a>
                            <p className="mt-1 text-left ">
                              Deerhold’s software development services use the
                              latest tech to help you reach your IT objectives
                              within today’s demanding timeframes.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-5 col-12 " to="/what-we-do">
                        <div className="nav-bar-style ">
                          <img src={whatwedo} alt="what-we-do" />

                          <div className="nav-details">
                            <a href="/what-we-do">What We Do</a>
                            <p className="mt-1  text-left ">
                              Deerhold stands out in the software development
                              industry because of its novel model. We tailor our
                              offshore and on-site development services to you.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <Link className="nav-link career-link " to="/careers">
              Careers
            </Link>
            <li>
              <a className="nav-link insights-link" role="button">
                Resources
              </a>
              <div className="collapse insights-nav">
                <div className="nav-full-dropdown ">
                  <div className="container text-left pt-2">
                    <div className="row">
                      <Link className="col-lg-3 col-12" to="/insights">
                        <div className="nav-bar-style ">
                          <img src={casestudy} alt="our-services" />

                          <div className="nav-details">
                            <a href="/insights">Case Study</a>
                            <p className="mt-1 text-left ">
                              Know our evolution story, global reach, excellent
                              digital solutions we build and why employees love
                              to work with us.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-3 col-12" to="/blogs">
                        <div className="nav-bar-style ">
                          <img src={blogs} alt="our-services" />

                          <div className="nav-details">
                            <a href="/blogs">Blogs</a>
                            <p className="mt-1 text-left ">
                              Discover expert insights, industry trends,
                              practical tips, and inspiring stories from our
                              thought leaders.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-3 col-12 " to="/news-list">
                        <div className="nav-bar-style ">
                          <img src={news} alt="news" />

                          <div className="nav-details">
                            <a href="/news-list">News</a>
                            <p className="mt-1  text-left ">
                              Get the latest news on what's happening in and
                              around Deerhold.
                            </p>
                          </div>
                        </div>
                      </Link>
                      <Link className="col-lg-3 col-12 " to="/media">
                        <div className="nav-bar-style ">
                          <img src={media} alt="news" />

                          <div className="nav-details">
                            <a href="/news-list">Media</a>
                            <p className="mt-1  text-left ">
                              Get the latest scoop on our company's activities,
                              achievements, and media features on our Media
                              page.
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <div className="nav-contact-btn">
              <BtnPrimary btnText="Contact Us" link="/contact" />
            </div>
            <a
              className="nav-link"
              href="https://japan.deerhold.com"
              target="_blank"
            >
              <img src={JapanFlag} alt="Japan" className="japanFlag" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
